var map = {
	"./5.jpg": "./resources/assets/site/img/5.jpg",
	"./alert_triangle_outline.svg": "./resources/assets/site/img/alert_triangle_outline.svg",
	"./arrow_left.svg": "./resources/assets/site/img/arrow_left.svg",
	"./arrow_right-white.svg": "./resources/assets/site/img/arrow_right-white.svg",
	"./arrow_right.svg": "./resources/assets/site/img/arrow_right.svg",
	"./arrow_undo.svg": "./resources/assets/site/img/arrow_undo.svg",
	"./arrow_up.svg": "./resources/assets/site/img/arrow_up.svg",
	"./arrows_expand.svg": "./resources/assets/site/img/arrows_expand.svg",
	"./award.svg": "./resources/assets/site/img/award.svg",
	"./banner-index-mobile.jpg": "./resources/assets/site/img/banner-index-mobile.jpg",
	"./banner-index.jpg": "./resources/assets/site/img/banner-index.jpg",
	"./banner-mobile.jpg": "./resources/assets/site/img/banner-mobile.jpg",
	"./banner-top-menu.jpg": "./resources/assets/site/img/banner-top-menu.jpg",
	"./banner.1036x140.jpg": "./resources/assets/site/img/banner.1036x140.jpg",
	"./banner.324x494.jpg": "./resources/assets/site/img/banner.324x494.jpg",
	"./banner.680x400.jpg": "./resources/assets/site/img/banner.680x400.jpg",
	"./box.svg": "./resources/assets/site/img/box.svg",
	"./burger.svg": "./resources/assets/site/img/burger.svg",
	"./calendar.svg": "./resources/assets/site/img/calendar.svg",
	"./care.01.svg": "./resources/assets/site/img/care.01.svg",
	"./care.02.svg": "./resources/assets/site/img/care.02.svg",
	"./care.03.svg": "./resources/assets/site/img/care.03.svg",
	"./care.04.svg": "./resources/assets/site/img/care.04.svg",
	"./care.05.svg": "./resources/assets/site/img/care.05.svg",
	"./care.06.svg": "./resources/assets/site/img/care.06.svg",
	"./care.07.svg": "./resources/assets/site/img/care.07.svg",
	"./care.08.svg": "./resources/assets/site/img/care.08.svg",
	"./care.09.svg": "./resources/assets/site/img/care.09.svg",
	"./care.10.svg": "./resources/assets/site/img/care.10.svg",
	"./care.11.svg": "./resources/assets/site/img/care.11.svg",
	"./care.12.svg": "./resources/assets/site/img/care.12.svg",
	"./care.13.svg": "./resources/assets/site/img/care.13.svg",
	"./care.14.svg": "./resources/assets/site/img/care.14.svg",
	"./carette_down.svg": "./resources/assets/site/img/carette_down.svg",
	"./cart-white.svg": "./resources/assets/site/img/cart-white.svg",
	"./cart.svg": "./resources/assets/site/img/cart.svg",
	"./chat_double.svg": "./resources/assets/site/img/chat_double.svg",
	"./check-main.svg": "./resources/assets/site/img/check-main.svg",
	"./check-white.svg": "./resources/assets/site/img/check-white.svg",
	"./check.svg": "./resources/assets/site/img/check.svg",
	"./check_circle_outline.svg": "./resources/assets/site/img/check_circle_outline.svg",
	"./checkbox-checked.svg": "./resources/assets/site/img/checkbox-checked.svg",
	"./checkbox-empty-disabled.svg": "./resources/assets/site/img/checkbox-empty-disabled.svg",
	"./checkbox-empty.svg": "./resources/assets/site/img/checkbox-empty.svg",
	"./chevron_down.svg": "./resources/assets/site/img/chevron_down.svg",
	"./chevron_down_small.svg": "./resources/assets/site/img/chevron_down_small.svg",
	"./chevron_left.svg": "./resources/assets/site/img/chevron_left.svg",
	"./chevron_left_small.svg": "./resources/assets/site/img/chevron_left_small.svg",
	"./chevron_right.svg": "./resources/assets/site/img/chevron_right.svg",
	"./chevron_right_smal-blue.svg": "./resources/assets/site/img/chevron_right_smal-blue.svg",
	"./chevron_right_smal.svg": "./resources/assets/site/img/chevron_right_smal.svg",
	"./chevron_up.svg": "./resources/assets/site/img/chevron_up.svg",
	"./chevron_up_small.svg": "./resources/assets/site/img/chevron_up_small.svg",
	"./clock-time.svg": "./resources/assets/site/img/clock-time.svg",
	"./close_times.svg": "./resources/assets/site/img/close_times.svg",
	"./close_times_circle.svg": "./resources/assets/site/img/close_times_circle.svg",
	"./cogs_gears_service.svg": "./resources/assets/site/img/cogs_gears_service.svg",
	"./collections.jpg": "./resources/assets/site/img/collections.jpg",
	"./color.jpg": "./resources/assets/site/img/color.jpg",
	"./color2.jpg": "./resources/assets/site/img/color2.jpg",
	"./color3.jpg": "./resources/assets/site/img/color3.jpg",
	"./color4.jpg": "./resources/assets/site/img/color4.jpg",
	"./cup.svg": "./resources/assets/site/img/cup.svg",
	"./cursor.svg": "./resources/assets/site/img/cursor.svg",
	"./delete_trash_bin-error.svg": "./resources/assets/site/img/delete_trash_bin-error.svg",
	"./delete_trash_bin.svg": "./resources/assets/site/img/delete_trash_bin.svg",
	"./delivery_lorry.svg": "./resources/assets/site/img/delivery_lorry.svg",
	"./detail.svg": "./resources/assets/site/img/detail.svg",
	"./detail.white.svg": "./resources/assets/site/img/detail.white.svg",
	"./diamomd_actions.svg": "./resources/assets/site/img/diamomd_actions.svg",
	"./doc_list_file.svg": "./resources/assets/site/img/doc_list_file.svg",
	"./dot.svg": "./resources/assets/site/img/dot.svg",
	"./empty.svg": "./resources/assets/site/img/empty.svg",
	"./eye_hidden.svg": "./resources/assets/site/img/eye_hidden.svg",
	"./eye_opened.svg": "./resources/assets/site/img/eye_opened.svg",
	"./fast_delivery_lorry.svg": "./resources/assets/site/img/fast_delivery_lorry.svg",
	"./filter.svg": "./resources/assets/site/img/filter.svg",
	"./filter_sliders.svg": "./resources/assets/site/img/filter_sliders.svg",
	"./footer-logo.svg": "./resources/assets/site/img/footer-logo.svg",
	"./globe_world_lang.svg": "./resources/assets/site/img/globe_world_lang.svg",
	"./grid_view_large_outline.svg": "./resources/assets/site/img/grid_view_large_outline.svg",
	"./grid_view_large_solid.svg": "./resources/assets/site/img/grid_view_large_solid.svg",
	"./grid_view_small_outline.svg": "./resources/assets/site/img/grid_view_small_outline.svg",
	"./grid_view_small_solid.svg": "./resources/assets/site/img/grid_view_small_solid.svg",
	"./hamburger.svg": "./resources/assets/site/img/hamburger.svg",
	"./heart_fav_outline-white.svg": "./resources/assets/site/img/heart_fav_outline-white.svg",
	"./heart_fav_outline.svg": "./resources/assets/site/img/heart_fav_outline.svg",
	"./heart_fav_solid-active-blue.svg": "./resources/assets/site/img/heart_fav_solid-active-blue.svg",
	"./heart_fav_solid-active.svg": "./resources/assets/site/img/heart_fav_solid-active.svg",
	"./heart_fav_solid.svg": "./resources/assets/site/img/heart_fav_solid.svg",
	"./help_question_circle.svg": "./resources/assets/site/img/help_question_circle.svg",
	"./i1.jpg": "./resources/assets/site/img/i1.jpg",
	"./i2.jpg": "./resources/assets/site/img/i2.jpg",
	"./i3.jpg": "./resources/assets/site/img/i3.jpg",
	"./i4.jpg": "./resources/assets/site/img/i4.jpg",
	"./i5.jpg": "./resources/assets/site/img/i5.jpg",
	"./i6.jpg": "./resources/assets/site/img/i6.jpg",
	"./icons-detail.svg": "./resources/assets/site/img/icons-detail.svg",
	"./image 22.jpg": "./resources/assets/site/img/image 22.jpg",
	"./image-top-1.jpg": "./resources/assets/site/img/image-top-1.jpg",
	"./image-top-2.jpg": "./resources/assets/site/img/image-top-2.jpg",
	"./image-top-3.jpg": "./resources/assets/site/img/image-top-3.jpg",
	"./image-top-mobile-1.jpg": "./resources/assets/site/img/image-top-mobile-1.jpg",
	"./image-top-mobile-2.jpg": "./resources/assets/site/img/image-top-mobile-2.jpg",
	"./image-top-mobile-3.jpg": "./resources/assets/site/img/image-top-mobile-3.jpg",
	"./image-top-mobile.jpg": "./resources/assets/site/img/image-top-mobile.jpg",
	"./image-top.jpg": "./resources/assets/site/img/image-top.jpg",
	"./image.324x324.jpg": "./resources/assets/site/img/image.324x324.jpg",
	"./image.jpg": "./resources/assets/site/img/image.jpg",
	"./images.jpg": "./resources/assets/site/img/images.jpg",
	"./index-category.jpg": "./resources/assets/site/img/index-category.jpg",
	"./info_circle outline-grey.svg": "./resources/assets/site/img/info_circle outline-grey.svg",
	"./info_circle outline.svg": "./resources/assets/site/img/info_circle outline.svg",
	"./item.1534x2286.jpg": "./resources/assets/site/img/item.1534x2286.jpg",
	"./item.356x400.jpg": "./resources/assets/site/img/item.356x400.jpg",
	"./item.682x1024.jpg": "./resources/assets/site/img/item.682x1024.jpg",
	"./item.80x120.jpg": "./resources/assets/site/img/item.80x120.jpg",
	"./keyboard_type.svg": "./resources/assets/site/img/keyboard_type.svg",
	"./l_delivery.svg": "./resources/assets/site/img/l_delivery.svg",
	"./l_diamond_actions.svg": "./resources/assets/site/img/l_diamond_actions.svg",
	"./l_present_gift.svg": "./resources/assets/site/img/l_present_gift.svg",
	"./l_shopping.svg": "./resources/assets/site/img/l_shopping.svg",
	"./l_stars_shine_new.svg": "./resources/assets/site/img/l_stars_shine_new.svg",
	"./list.svg": "./resources/assets/site/img/list.svg",
	"./list.white.svg": "./resources/assets/site/img/list.white.svg",
	"./lock_locked.svg": "./resources/assets/site/img/lock_locked.svg",
	"./log_out_exit.svg": "./resources/assets/site/img/log_out_exit.svg",
	"./logo.svg": "./resources/assets/site/img/logo.svg",
	"./mail_envelope.svg": "./resources/assets/site/img/mail_envelope.svg",
	"./map.svg": "./resources/assets/site/img/map.svg",
	"./map.white.svg": "./resources/assets/site/img/map.white.svg",
	"./menu_hamburger-white.svg": "./resources/assets/site/img/menu_hamburger-white.svg",
	"./menu_hamburger.svg": "./resources/assets/site/img/menu_hamburger.svg",
	"./metro.svg": "./resources/assets/site/img/metro.svg",
	"./minus.svg": "./resources/assets/site/img/minus.svg",
	"./minus_delete_circle.svg": "./resources/assets/site/img/minus_delete_circle.svg",
	"./more_ellipsis_circle_outline.svg": "./resources/assets/site/img/more_ellipsis_circle_outline.svg",
	"./navigation.svg": "./resources/assets/site/img/navigation.svg",
	"./no-photo.svg": "./resources/assets/site/img/no-photo.svg",
	"./phone-1.svg": "./resources/assets/site/img/phone-1.svg",
	"./phone.svg": "./resources/assets/site/img/phone.svg",
	"./phone_incoming.svg": "./resources/assets/site/img/phone_incoming.svg",
	"./play.svg": "./resources/assets/site/img/play.svg",
	"./play_circle_outline.svg": "./resources/assets/site/img/play_circle_outline.svg",
	"./play_circle_solid.svg": "./resources/assets/site/img/play_circle_solid.svg",
	"./plus.svg": "./resources/assets/site/img/plus.svg",
	"./plus_circle.svg": "./resources/assets/site/img/plus_circle.svg",
	"./pp.svg": "./resources/assets/site/img/pp.svg",
	"./present.svg": "./resources/assets/site/img/present.svg",
	"./present_gift.svg": "./resources/assets/site/img/present_gift.svg",
	"./rectangle345.jpg": "./resources/assets/site/img/rectangle345.jpg",
	"./response_arrow.svg": "./resources/assets/site/img/response_arrow.svg",
	"./route.svg": "./resources/assets/site/img/route.svg",
	"./route.white.svg": "./resources/assets/site/img/route.white.svg",
	"./rutube.svg": "./resources/assets/site/img/rutube.svg",
	"./sale_discount.svg": "./resources/assets/site/img/sale_discount.svg",
	"./sbp_logo.svg": "./resources/assets/site/img/sbp_logo.svg",
	"./search.svg": "./resources/assets/site/img/search.svg",
	"./search_magnif-white.svg": "./resources/assets/site/img/search_magnif-white.svg",
	"./settings_cog_gear.svg": "./resources/assets/site/img/settings_cog_gear.svg",
	"./shopping.svg": "./resources/assets/site/img/shopping.svg",
	"./social_facebook.svg": "./resources/assets/site/img/social_facebook.svg",
	"./social_instagram.svg": "./resources/assets/site/img/social_instagram.svg",
	"./social_odnoklassniki.svg": "./resources/assets/site/img/social_odnoklassniki.svg",
	"./social_vkontakte.svg": "./resources/assets/site/img/social_vkontakte.svg",
	"./social_youtube.svg": "./resources/assets/site/img/social_youtube.svg",
	"./sort_asc.svg": "./resources/assets/site/img/sort_asc.svg",
	"./sort_desc.svg": "./resources/assets/site/img/sort_desc.svg",
	"./sorting_alt.svg": "./resources/assets/site/img/sorting_alt.svg",
	"./spinner_animated.svg": "./resources/assets/site/img/spinner_animated.svg",
	"./star_half.svg": "./resources/assets/site/img/star_half.svg",
	"./star_outline.svg": "./resources/assets/site/img/star_outline.svg",
	"./star_solid.svg": "./resources/assets/site/img/star_solid.svg",
	"./star_third.svg": "./resources/assets/site/img/star_third.svg",
	"./star_two-thirds.svg": "./resources/assets/site/img/star_two-thirds.svg",
	"./stars_shine_new.svg": "./resources/assets/site/img/stars_shine_new.svg",
	"./support.svg": "./resources/assets/site/img/support.svg",
	"./tags.svg": "./resources/assets/site/img/tags.svg",
	"./telegram.svg": "./resources/assets/site/img/telegram.svg",
	"./union.svg": "./resources/assets/site/img/union.svg",
	"./union2.svg": "./resources/assets/site/img/union2.svg",
	"./union3.svg": "./resources/assets/site/img/union3.svg",
	"./union4.svg": "./resources/assets/site/img/union4.svg",
	"./union5.svg": "./resources/assets/site/img/union5.svg",
	"./union6.svg": "./resources/assets/site/img/union6.svg",
	"./union7.svg": "./resources/assets/site/img/union7.svg",
	"./user.svg": "./resources/assets/site/img/user.svg",
	"./user_circle-main.svg": "./resources/assets/site/img/user_circle-main.svg",
	"./user_circle-white.svg": "./resources/assets/site/img/user_circle-white.svg",
	"./user_circle.svg": "./resources/assets/site/img/user_circle.svg",
	"./userpic_photo_32.jpg": "./resources/assets/site/img/userpic_photo_32.jpg",
	"./video-pause.png": "./resources/assets/site/img/video-pause.png",
	"./video-play.png": "./resources/assets/site/img/video-play.png",
	"./video.snapshot.jpg": "./resources/assets/site/img/video.snapshot.jpg",
	"./whatsapp.svg": "./resources/assets/site/img/whatsapp.svg",
	"./yandex-zen.svg": "./resources/assets/site/img/yandex-zen.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/assets/site/img sync recursive \\.(png%7Cjpg%7Cjpeg%7Csvg%7Cwebp)$";